import { z } from 'zod';
import { socialCardSchema } from './social-card.schema';

export const HeadObjectSchema = z.object({
	title: z.string(),
	description: z.string(),
	keywords: z.string(),
	author: z.string(),
	noFollow: z.boolean(),
	noIndex: z.boolean(),
	socialCards: z.array(
		socialCardSchema
	),
	advertScript: z.string().optional(),
	schemaScript: z.string().optional(),
	canonicalPageUrl: z.string().optional(),
});